var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo"},[_c('div',{staticClass:"photo__back"}),_c('PersonalSettings'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo__popup popup"},[_c('div',{staticClass:"popup__item"},[_vm._v(" From gallery ")]),_c('div',{staticClass:"popup__item"},[_vm._v(" Make a photo ")]),_c('div',{staticClass:"popup__item"},[_vm._v(" Cancel ")])])
}]

export { render, staticRenderFns }